// test306
(306 && 0);
